import DataType from '@opsbase/lib-datatype/DataType';
import Pages from '@opsbase/lib-pages';
import i18n from '@opsbase/lib-i18n';
import AppPage from '@opsbase/web-app/AppPage';
import DVLPage from '@opsbase/web-dvl-page';
import React from 'react';
import TeamSelectionToolbar from '../toolbars/TeamSelectionToolbar';
export function AdvancedTeamsPage() {
    return (React.createElement(AppPage, null,
        React.createElement(DVLPage, { viewId: DataType.TEAM, itemPage: Pages.TEAMS_EDIT, itemCreatePage: Pages.TEAMS_CREATE, itemDeletePage: Pages.TEAMS_DELETE, notFoundText: i18n.t('no-teams-found'), itemSelectionToolbar: React.createElement(TeamSelectionToolbar, null) })));
}
export default AdvancedTeamsPage;
